import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=17820c9c&scoped=true&lang=pug"
import script from "./InfoBanner.vue?vue&type=script&lang=js"
export * from "./InfoBanner.vue?vue&type=script&lang=js"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=17820c9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17820c9c",
  null
  
)

export default component.exports